import * as React from "react";

import FormContainer from "../../layout/FormContainer/FormContainer";
import {FormComponent} from "../../state/FormsState";
import { RouteComponentProps } from "react-router-dom";

interface IProps extends RouteComponentProps<any> {}

export default class FormManageLoanPlanContainer  extends React.Component<
    IProps
    > {
    public render() {
        return (
            <FormContainer initialComponent={FormComponent.manageLoan} {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormManageLoanPlan/FormManageLoanPlanContainer.tsx